export default "<app-top-nav></app-top-nav>\n<section class=\"main-container\">\n\t<app-loader></app-loader>\n\t<router-outlet></router-outlet>\n</section>"